__turbopack_context__.v({
  "root": "Moon-module__XDPMzW__root",
});
